export type ScrollEvaluation = {
	shouldFetchMore: boolean;
	shouldRemoveScroll: boolean;
};

export const shouldTriggerInfiniteScroll = (
	scrollPosition: number,
	containerHeight: number,
	canFetchMore: boolean,
	nextPage: number,
	halfwayIndex: number,
): ScrollEvaluation => {
	const scrollThreshold = containerHeight * 0.6;
	const nearEndOfPage = scrollPosition >= scrollThreshold;

	return {
		shouldFetchMore: nearEndOfPage && canFetchMore,
		shouldRemoveScroll: nextPage === halfwayIndex || !canFetchMore,
	};
};
